import * as React from "react";
function SvgDash(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M0 21h48v6H0v-6z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDash);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
